import React from 'react'
import { withStyles } from 'material-ui/styles'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'
import ProductControls from '../products/ProductControls'
import CircularProgress from 'material-ui/Progress/CircularProgress'
import green from 'material-ui/colors/green'

const style = theme => ({
  root: {
    flexDirection: 'column'
  },
  wrapper: {
    margin: theme.spacing.unit,
    position: 'relative'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '20px',
    left: '60px',
    marginTop: -12,
    marginLeft: -12
  }
})

const ProductForm = props => {
  const {
    classes,
    productName,
    productId,
    productManufacturer,
    onProductChange,
    onProductSave,
    requestOngoing,
    successMsg
  } = props
  return (
    <div>
      <ProductControls />
      <form noValidate autoComplete='off' className={classes.root}>
        <TextField
          id='id'
          label='Product id'
          margin='normal'
          type='number'
          fullWidth
          value={productId}
          onChange={e => onProductChange({ _id: parseInt(e.target.value, 10) })}
        />
        <TextField
          id='name'
          label='Product Name'
          margin='normal'
          fullWidth
          value={productName}
          onChange={e => onProductChange({ name: e.target.value })}
        />
        <TextField
          id='manufacturer'
          label='Manufacturer'
          margin='normal'
          fullWidth
          value={productManufacturer}
          onChange={e => onProductChange({ manufacturer: e.target.value })}
        />
        <div className={classes.wrapper}>
          <Button
            color='primary'
            disabled={requestOngoing || productName === '' || !productId}
            variant='raised'
            onClick={onProductSave}
          >
            Save Product
          </Button>{' '}
          &nbsp;
          {requestOngoing && (
            <CircularProgress size={24} className={classes.buttonProgress} />
          )}
          {!requestOngoing && successMsg}
        </div>
      </form>
    </div>
  )
}

ProductForm.defaultProps = {
  productId: undefined,
  productName: '',
  productManufacturer: ''
}

export default withStyles(style)(ProductForm)



// WEBPACK FOOTER //
// ./src/products/ProductForm.js